import { useNarrow } from '../../../lib/use-narrow';
import { DesktopHomeHeader } from './DesktopHomeHeader';
import { MobileHomeHeader } from './MobileHomeHeader';

// `home2` renders only the header top — the agents island, greeting and date —
// dropping the brief row / QR beneath it, so the Home 2 surface starts from a clean header.
export function HomeHeader({ home2 = false }: { home2?: boolean }) {
  const narrow = useNarrow();
  return narrow ? <MobileHomeHeader home2={home2} /> : <DesktopHomeHeader home2={home2} />;
}
